// https://github.com/microsoft/TypeScript/issues/36444#issuecomment-578572999

function createTrack(element) {
  return function (eventName, payload) {
    track(element, eventName, payload);
  };
}
function track(element, eventName, payload) {
  const trackEvent = new CustomEvent("track", {
    detail: {
      eventName,
      payload: {
        ...(payload ? payload : {}),
      },
    },
  });
  element.dispatchEvent(trackEvent);
}
function trackUserActivity(element, eventName, payload) {
  const trackEvent = new CustomEvent("trailhead_track", {
    bubbles: true,
    composed: true,
    detail: {
      eventName,
      payload: {
        ...(payload ? payload : {}),
      },
    },
  });
  element.dispatchEvent(trackEvent);
}
function trackUserActivityLearning(element, learning, payload) {
  let activityPayload = getUserActivityLearningActionPayload(learning, payload);
  switch (activityPayload.learning_type) {
    case "MODULE":
      trackUserActivity(element, "module_clicked", activityPayload);
      break;
    case "PROJECT":
      trackUserActivity(element, "project_clicked", activityPayload);
      break;
    case "SUPERBADGE":
      trackUserActivity(element, "superbadge_clicked", activityPayload);
      break;
    case "TRAIL":
      trackUserActivity(element, "trail_clicked", activityPayload);
      break;
    case "TRAILMIX":
      trackUserActivity(element, "trailmix_clicked", activityPayload);
      break;
  }
}
function getUserActivityLearningActionPayload(learning, payload) {
  let type = learning.type;
  switch (type) {
    case "MODULE":
      return {
        ...payload,
        learning_type: type,
        module_api_name: learning.name,
        module_uid: learning.id,
      };
    case "PROJECT":
      return {
        ...payload,
        learning_type: type,
        project_api_name: learning.name,
        project_uid: learning.id,
      };
    case "SUPERBADGE":
      return {
        ...payload,
        learning_type: type,
        superbadge_api_name: learning.name,
        superbadge_uid: learning.id,
      };
    case "TRAIL":
      return {
        ...payload,
        learning_type: type,
        trail_api_name: learning.name,
        trail_uid: learning.id,
      };
    case "TRAILMIX":
      return {
        ...payload,
        learning_type: type,
        trailmix_api_name: learning.name,
        trailmix_uid: learning.id,
      };
    default:
      return {};
  }
}

export {
  createTrack,
  getUserActivityLearningActionPayload,
  track,
  trackUserActivity,
  trackUserActivityLearning,
};
